import { EventEmitter, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export enum Events {
  'OPEN_ENTITY_SELECTOR',
  'OPEN_ENTITY_DETAILS',
  'ENTITY_SELECTED',
}

@Injectable()
export class GenericEditorEventProvider {
  private subject$ = new Subject();

  emit(event: any) {
    this.subject$.next(event);
  }
  on(event, action): Subscription {
    return this.subject$
      .pipe(
        filter((e: any) => e.name == event),
        map((e: any) => e.value)
      )
      .subscribe(action);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/GenericEditorStateProvider.ts